import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';

var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "min-w-0 w-full" },
    [
      _c(
        VCard,
        {
          staticClass: "mx-auto pt-3",
          attrs: {
            flat: "",
            "max-width": "1200",
            tile: "",
            loading: _vm.isLoading,
          },
          scopedSlots: _vm._u([
            {
              key: "progress",
              fn: function () {
                return [_c("base-loading-component")]
              },
              proxy: true,
            },
          ]),
        },
        [
          !_vm.isLoading
            ? _c(
                VCardText,
                [
                  _c(
                    VRow,
                    _vm._l(_vm.userInfo.userRoles, function (role) {
                      return _c(
                        VCol,
                        { key: role, attrs: { cols: "6" } },
                        [
                          _c(
                            VRow,
                            [
                              _c(
                                VCol,
                                { staticClass: "pr-0", attrs: { cols: "6" } },
                                [
                                  _c(VTextField, {
                                    attrs: {
                                      filled: "",
                                      rounded: "",
                                      readonly: "",
                                      "hide-details": "",
                                      dense: "",
                                      value: _vm.getRoleName(role),
                                      "prepend-inner-icon": "icon-user",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                VCol,
                                { staticClass: "pl-1", attrs: { cols: "6" } },
                                [
                                  _c(VTextField, {
                                    attrs: {
                                      filled: "",
                                      rounded: "",
                                      readonly: "",
                                      "hide-details": "",
                                      dense: "",
                                      value: role,
                                      "prepend-inner-icon": "icon-ray",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(VTextField, {
                            staticClass: "pt-2",
                            attrs: {
                              filled: "",
                              rounded: "",
                              "background-color": "#f9f9f9",
                              readonly: "",
                              dense: "",
                              value: _vm.rolesInca[role]
                                ? _vm.rolesInca[role].description
                                : _vm.$t("frases.no_description"),
                            },
                          }),
                        ],
                        1
                      )
                    }),
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }